import { useFormik } from 'formik';
import { initialValues, validationSchema } from './formData';
import { ISelect, ParamEnum } from '../../../../../../shared/types/shared';
import { useEffect, useState } from 'react';
import { PqrResponseMedium } from '../../../../../../shared/types/modules/pqr';
import { PqrResponseMediumProps } from './props';
import { asyncGetParams } from '../../../../../../services/param.service';

export const usePqrResponseMedium = ({
    data,
    onChangeData,
    onChangeFormik,
}: PqrResponseMediumProps) => {
    const [responseMediums, setResponseMediums] = useState<ISelect[]>([]);

    const onSubmit = (data: PqrResponseMedium) => {
        if (onChangeData) onChangeData(data || {});
    };

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit,
    });

    useEffect(() => {
        if (onChangeFormik) onChangeFormik(formik);
    }, [formik.values, formik.errors]);

    useEffect(() => {
        formik?.setFieldValue('responseMedium', data?.responseMedium || '');
        formik?.setFieldValue('observation', data?.observation || '');
    }, [data]);

    useEffect(() => {
        asyncGetParams(ParamEnum.PQR_RESPONSE_MEDIUM).then((items) =>
            setResponseMediums(items)
        );
    }, []);

    return {
        formik,
        responseMediums,
    };
};
